<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">{{$t('views.promo_codes.group')}}</h4>
            <div class="form-group">
              <select v-model="selectedGroup" class="form-control form-control-sm">
                <option v-for="item in groups" :key="item.id" :value="item.id">
                  {{item.codename}} ({{ item.description }})
                </option>
              </select>
            </div>

            <div class="row">
              <div class="col-12 text-right">
                <div @click="showAddGroupPopup" class="btn btn-sm btn-success">
                  <i class="fa fa-plus"></i>
                  {{ $t('views.promo_codes.group') }}
                </div>
                <div v-show="selectedGroup > 0" @click="showDeleteGroupPopup" class="btn btn-sm btn-danger ml-2">
                  <i class="fa fa-times"></i>
                  {{ $t('views.promo_codes.group') }}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="row">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">

            <div v-if="selectedGroup > 0" class="row">
              <div class="col-12 text-right">
                <div @click="download" class="btn btn-sm btn-success">
                  <i class="fa fa-download"></i>
                  Выгрузить в CSV
                </div>
                &nbsp;
                <div @click="showAddPromocodePopup" class="btn btn-sm btn-success">
                  <i class="fa fa-plus"></i>
                  {{ $t('views.promo_codes.promo_code') }}
                </div>
              </div>
            </div>

            <div v-if="selectedGroup > 0" class="row mt-3">
              <div class="col-12">
                <table class="table table-hover mb-0">
                  <thead>
                    <tr>
                      <th>Код</th>
                      <th>Скидка, %
                        <span  @click="toggleSort('discount')">
                          <template v-if="this.sortField === 'discount'">
                              <i class="cursor-pointer fa" :class="this.sortDesc ? 'fa-arrow-down' : 'fa-arrow-up'"></i>
                          </template>
                            <template v-else>
                              <i class="cursor-pointer fa fa-arrows-alt-v text-muted small" ></i>
                            </template>
                        </span>
                      </th>
                      <th>Активен?</th>
                      <th>{{$t('views.promo_codes.end_datetime')}}
                        <span  @click="toggleSort('valid_until')">
                          <template v-if="this.sortField === 'valid_until'">
                              <i class="cursor-pointer fa" :class="this.sortDesc ? 'fa-arrow-down' : 'fa-arrow-up'"></i>
                          </template>
                            <template v-else>
                              <i class="cursor-pointer fa fa-arrows-alt-v text-muted small" ></i>
                            </template>
                        </span>
                      </th>
                      <th>Количество заказов
                        <span  @click="toggleSort('usage_count')">
                          <template v-if="this.sortField === 'usage_count'">
                              <i class="cursor-pointer fa" :class="this.sortDesc ? 'fa-arrow-down' : 'fa-arrow-up'"></i>
                          </template>
                            <template v-else>
                              <i class="cursor-pointer fa fa-arrows-alt-v text-muted small" ></i>
                            </template>
                        </span>
                      </th>
                      <th>Сумма заказов
                        <span  @click="toggleSort('usage_sum')">
                          <template v-if="this.sortField === 'usage_sum'">
                              <i class="cursor-pointer fa" :class="this.sortDesc ? 'fa-arrow-down' : 'fa-arrow-up'"></i>
                          </template>
                            <template v-else>
                              <i class="cursor-pointer fa fa-arrows-alt-v text-muted small" ></i>
                            </template>
                        </span>
                      </th>
                      <th>{{$t('popularWords.actions')}}</th>
                    </tr>
                  </thead>
                  <tbody class="mt-3" v-for="(item, index) in promoCodes" :key="index">
                    <tr>
                      <td>{{item.code}}</td>
                      <td>{{item.discount}}</td>
                      <td>
                        <div @click="toggleActivation(item.id)" class="btn btn-sm" :class="item.is_active == 0 ? 'btn-danger' : 'btn-success'">
                          <template v-if="item.is_active == 0">
                            <i class="fa fa-times"></i>
                          </template>
                          <template v-else>
                              <i class="fa fa-check"></i>
                          </template>
                        </div>
                      </td>
                      <td>{{phpDatetimeToString(item.valid_until)}}</td>
                      <td>{{item.usage_count}}</td>
                      <td>{{item.usage_sum}}</td>
                      <td>
                        <div @click="showDeletePromocodePopup(item.id)" class="btn btn-sm btn-danger">
                          <i class="fa fa-times"></i>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <popup
      :closeButton="addGroupPopup.closeButton"
      :actionButton="addGroupPopup.actionButton"
      :actionClass="addGroupPopup.actionClass"
      :show="addGroupPopup.show"
      @closePopup="closeAddGroupPopup"
      @actionPopup="addGroupPopupSubmit"
    >
      <div slot="header">{{$t('views.promo_codes.add_group')}}</div>
      <div slot="body">
        <form class="needs-validation">
          <div class="form-group">
            <label for="newGroup_codename">{{ $t('views.promo_codes.group_name') }}</label>
            <input
                id="newGroup_codename"
                v-model="newGroup.codename"
                type="text"
                class="form-control form-control-sm"
                :class="{ 'is-invalid': submitted && $v.newGroup.codename.$error }"
            />
            <small class="form-text text-muted">
              {{ $t('views.promo_codes.in_latin') }}
            </small>
            <div v-if="submitted && $v.newGroup.codename.$error" class="invalid-feedback">
              <span v-if="!$v.newGroup.codename.required">{{ $t('validatePhrases.requiredField') }}</span>
              <span v-if="!$v.newGroup.codename.minLength">
                {{ $t('validatePhrases.minLength') }} - 1
              </span>
              <span v-if="!$v.newGroup.codename.maxLength">
                {{ $t('validatePhrases.maxLength') }} - 40
              </span>
            </div>
          </div>
          <div class="form-group">
            <label for="newGroup_description">{{ $t('popularWords.description') }}</label>
            <textarea 
              rows="2"
              v-model="newGroup.description"
              class="form-control form-control-sm"
              :class="{ 'is-invalid': submitted && $v.newGroup.description.$error }"
            ></textarea>
            <div v-if="submitted && $v.newGroup.description.$error" class="invalid-feedback">
              <span v-if="!$v.newGroup.description.required">{{ $t('validatePhrases.requiredField') }}</span>
              <span v-if="!$v.newGroup.description.minLength">
                {{ $t('validatePhrases.minLength') }} - 1
              </span>
              <span v-if="!$v.newGroup.description.maxLength">
                {{ $t('validatePhrases.maxLength') }} - 255
              </span>
            </div>
          </div>
        </form>
      </div>
    </popup>

    <popup
      :closeButton="deleteGroupPopup.closeButton"
      :actionButton="deleteGroupPopup.actionButton"
      :actionClass="deleteGroupPopup.actionClass"
      :show="deleteGroupPopup.show"
      @closePopup="closeDeleteGroupPopup"
      @actionPopup="deleteGroupPopupSubmit"
    >
      <div slot="header">{{$t('views.promo_codes.delete_group')}}</div>
      <div slot="body">
        {{$t('views.promo_codes.delete_group_text')}}
      </div>
    </popup>


    <popup
      :closeButton="addPromocodePopup.closeButton"
      :actionButton="addPromocodePopup.actionButton"
      :actionClass="addPromocodePopup.actionClass"
      :show="addPromocodePopup.show"
      @closePopup="closeAddPromocodePopup"
      @actionPopup="addPromocodePopupSubmit"
    >
      <div slot="header">{{$t('views.promo_codes.add_promocode')}}</div>
      <div slot="body">
        <form class="needs-validation">
          <div class="form-group">
            <label for="newPromocode_codename">Код (четыре буквы, две цифры)</label>
            <input
                id="newPromocode_codename"
                v-model="newPromocode.code"
                type="text"
                class="form-control form-control-sm"
                :class="{ 'is-invalid': submitted && $v.newPromocode.code.$error }"
            />
            <small class="form-text text-muted">
              {{ $t('views.promo_codes.in_latin') }}
            </small>
            <div v-if="submitted && $v.newPromocode.code.$error" class="invalid-feedback">
              <span v-if="!$v.newPromocode.code.required">{{ $t('validatePhrases.requiredField') }}</span>
              <span v-if="!$v.newPromocode.code.minLength">
                {{ $t('validatePhrases.minLength') }} - 6
              </span>
              <span v-if="!$v.newPromocode.code.maxLength">
                {{ $t('validatePhrases.maxLength') }} - 6
              </span>
            </div>
          </div>
          <div class="form-group">
            <label for="newPromocode_bonus_sum">Скидка, %}</label>
            <input
                id="newPromocode_bonus_sum"
                v-model="newPromocode.discount"
                type="text"
                class="form-control form-control-sm"
                :class="{ 'is-invalid': submitted && $v.newPromocode.discount.$error }"
            />
            <div v-if="submitted && $v.newPromocode.discount.$error" class="invalid-feedback">
              <span v-if="!$v.newPromocode.discount.required">{{ $t('validatePhrases.requiredField') }}</span>
              <span v-if="!$v.newPromocode.discount.minValue">
                {{ $t('validatePhrases.minValue') }} - 1
              </span>
              <span v-if="!$v.newPromocode.discount.maxValue">
                {{ $t('validatePhrases.maxValue') }} - 100
              </span>
            </div>
          </div>
          <div class="form-group">
            <label for="newPromocode_is_work_after_first_pay">Активировать?</label>
            <select v-model="newPromocode.is_active" class="form-control form-control-sm">
              <option value="0">{{ $t('popularWords.no') }}</option>
              <option value="1">{{ $t('popularWords.yes') }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="newPromocode_end_dt">Истекает</label>
            <date-picker v-model="newPromocode.valid_until" append-to-body :lang="pickerLang" :format="'DD MMM YYYY'"
              :type="'date'" :valueType="'YYYY-MM-DD'" confirm class="mr-0 form-control-sm">
            </date-picker>
            <div v-if="submitted && $v.newPromocode.valid_until.$error" class="invalid-feedback">
              <span v-if="!$v.newPromocode.valid_until.required">{{ $t('validatePhrases.requiredField') }}</span>
            </div>
          </div>
        </form>
      </div>
    </popup>


    <popup
      :closeButton="deletePromocodePopup.closeButton"
      :actionButton="deletePromocodePopup.actionButton"
      :actionClass="deletePromocodePopup.actionClass"
      :show="deletePromocodePopup.show"
      @closePopup="closeDeletePromocodePopup"
      @actionPopup="deletePromocodePopupSubmit"
    >
      <div slot="header">{{$t('views.promo_codes.delete_promocode')}}</div>
      <div slot="body">
        {{$t('views.promo_codes.delete_promocode_text')}}
      </div>
    </popup>


  </Layout>
</template>


<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DatePicker from "vue2-datepicker";

import axios from "axios";
import Popup from '../../../components/Popup.vue';
import Formatter from "../../../components/libraries/Formatter";

const formatter = new Formatter();

import {
  required,
  minLength,
  maxLength,
  minValue,
  maxValue
} from "vuelidate/lib/validators";


export default {
  components: {
    Layout,
    PageHeader,
    Popup,
    DatePicker
},
  data() {
    return {
      sortDesc: true,
      sortField: 'usage_count',
      submitted: false,

      groups: [],
      selectedGroup: 0,

      promoCodes: [],

      addGroupPopup: {
        show: false,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.add'),
        actionClass: "btn-success"
      },
      deleteGroupPopup: {
        show: false,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.confirm'),
        actionClass: "btn-success"
      },
      newGroup: {
        codename: '',
        description: ''
      },

      addPromocodePopup: {
        show: false,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.add'),
        actionClass: "btn-success"
      },
      deletePromocodePopup: {
        show: false,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.confirm'),
        actionClass: "btn-success"
      },
      deletedPromocodeId: 0,
      newPromocode: {
        code: '',
        discount: 0,
        is_active: 0,
        valid_until: ''
      },

      pickerLang: {
        formatLocale: {
          firstDayOfWeek: 1,
          months: this.$t('datepicker.months'),
          weekdaysMin: this.$t('datepicker.weekdaysMin'),
          monthsShort: this.$t('datepicker.monthsShort'),
        },
        monthBeforeYear: false,
      },

      title: this.$t('menuitems.management.list.promo_codes'),
      items: [
        {
          text: this.$t('menuitems.management.text'),
        },
        {
          text: this.$t('menuitems.management.list.promo_codes'),
          active: true
        }
      ],
    };
  },
  validations: {
    newGroup: {
      codename: { required, minLength: minLength(1), maxLength: maxLength(40) },
      description: { required, minLength: minLength(1), maxLength: maxLength(255) },
    },
    newPromocode: {
      code: { required, minLength: minLength(6), maxLength: maxLength(6) },
      discount: { required, minValue: minValue(1), maxValue: maxValue(100) },
      valid_until: { required }
    },
  },
  computed: {

  },
  watch: {
    selectedGroup: function(val){
      if(val > 0){
        this.getPromocodes(val);
      }
    }
  },
  methods: {
    showDeleteGroupPopup(){
      this.deleteGroupPopup.show = true;
    },
    closeDeleteGroupPopup(){
      this.deleteGroupPopup.show = false;
    },
    deleteGroupPopupSubmit(){
      this.$store.dispatch("startPreloader");
      let formData = new FormData();
      formData.append('id', this.selectedGroup);

      axios
          .post(`/v1/localization/delete-group-promocode`, formData)
          .then(() => {
            this.$store.dispatch("stopPreloader");
            this.closeDeleteGroupPopup();
            this.selectedGroup = 0;
            this.promoCodes = [];
            this.getGroups();
          })
          .catch(err => {
            this.$store.dispatch("stopPreloader");
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          });
    },
    showAddGroupPopup(){
      this.addGroupPopup.show = true;
    },
    closeAddGroupPopup(){
      this.addGroupPopup.show = false;
    },
    showDeletePromocodePopup(promocode_id){
      this.deletedPromocodeId = promocode_id;
      this.deletePromocodePopup.show = true;
    },
    closeDeletePromocodePopup(){
      this.deletePromocodePopup.show = false;
    },
    deletePromocodePopupSubmit(){
      this.$store.dispatch("startPreloader");
      let formData = new FormData();
      formData.append('id', this.deletedPromocodeId);

      axios
          .post(`/v1/discount-codes/delete-promocode`, formData)
          .then(() => {
            this.$store.dispatch("stopPreloader");
            this.closeDeletePromocodePopup();
            this.getPromocodes(this.selectedGroup);
          })
          .catch(err => {
            this.$store.dispatch("stopPreloader");
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          });
    },
    addGroupPopupSubmit(){
      this.submitted = true;
      // stop here if form is invalid
      this.$v.newGroup.$touch();
      if(!this.$v.newGroup.$invalid){
        this.$store.dispatch("startPreloader");
        let formData = new FormData();
        formData.append('codename', this.newGroup.codename);
        formData.append('description', this.newGroup.description);

        axios
            .post(`/v1/localization/set-group-promocode`, formData)
            .then(() => {
              this.$store.dispatch("stopPreloader");
              this.closeAddGroupPopup();
              this.newGroup.codename = '';
              this.newGroup.description = '';
              this.getGroups();
              this.submitted = false;
            })
            .catch(err => {
              this.submitted = false;
              this.$store.dispatch("stopPreloader");
              this.$store.dispatch("addNotification", {
                text: err.response.data.message,
                time: 6,
                color: "danger"
              });
            }); 
      }
    },
    toggleSort(field) {
      if (this.sortField === field) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortField = field;
      }
      this.getPromocodes(this.selectedGroup);
    },
    toggleActivation(id){
      this.$store.dispatch("startPreloader");
      let formData = new FormData();
      formData.append('id', id);

      axios
          .post(`/v1/discount-codes/toggle-activation`, formData)
          .then(() => {
            this.$store.dispatch("stopPreloader");
            this.$store.dispatch("addNotification", {
              text: "Успешно изменено",
              time: 6,
              color: "success"
            });
            this.getPromocodes(this.selectedGroup);
          })
          .catch(err => {
            this.$store.dispatch("stopPreloader");
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          });
    },
    download(){
      this.$store.dispatch("startPreloader");
      let formData = new FormData();
      formData.append('group_id', this.selectedGroup);

      axios
          .post(`/v1/discount-codes/download`, formData)
          .then(resp => {
            this.$store.dispatch("stopPreloader");
            const blob = new Blob([resp.data], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `promocodes_${this.selectedGroup}.csv`;
            a.click();
          })
          .catch(err => {
            this.$store.dispatch("stopPreloader");
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          });
    },
    showAddPromocodePopup(){
      this.addPromocodePopup.show = true;
    },
    closeAddPromocodePopup(){
      this.addPromocodePopup.show = false;
    },
    addPromocodePopupSubmit(){
      this.submitted = true;
      // stop here if form is invalid
      this.$v.newPromocode.$touch();
      if(!this.$v.newPromocode.$invalid){
        this.$store.dispatch("startPreloader");
        let formData = new FormData();
        formData.append('promo_code_group_id', this.selectedGroup);
        for (const key in this.newPromocode){
          formData.append(key, this.newPromocode[key]);
        }


        axios
            .post(`/v1/discount-codes/create`, formData)
            .then(() => {
              this.$store.dispatch("stopPreloader");
              this.closeAddPromocodePopup();
              this.newPromocode.code = '';
              this.newPromocode.discount = 0;
              this.newPromocode.is_active = 0;
              this.newPromocode.valid_until = '';
              this.getPromocodes(this.selectedGroup);
              this.submitted = false;
            })
            .catch(err => {
              this.submitted = false;
              this.$store.dispatch("stopPreloader");
              this.$store.dispatch("addNotification", {
                text: err.response.data.message,
                time: 6,
                color: "danger"
              });
            }); 
      }
    },
    getPromocodes(group_id){
      this.$store.dispatch("startPreloader");
      let formData = new FormData();
      formData.append('group_id', group_id);

      axios
          .post(`/v1/discount-codes/get-promocodes?sort=${(this.sortDesc ? '' : '-') + this.sortField}`, formData)
          .then(resp => {
            this.$store.dispatch("stopPreloader");
            this.promoCodes = resp.data;
          })
          .catch(err => {
            this.$store.dispatch("stopPreloader");
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          });
    },
    getGroups(){
      this.$store.dispatch("startPreloader");
      axios
          .get(`/v1/discount-codes/groups`)
          .then(resp => {
            this.$store.dispatch("stopPreloader");
            this.groups = resp.data;
          })
          .catch(err => {
            this.$store.dispatch("stopPreloader");
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          });
    },
    phpDatetimeToString(datetime){
      return formatter.phpDateTimeToShortString(datetime);
    }
  },
  created() {
    this.getGroups();
  }
};
</script>

<style scoped lang="scss">
  
</style>
